export default {"src":"/_next/static/media/clown_24.e741b4be.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};